import React from 'react';

import {
  Box,
  Typography,
  styled
} from '@mui/material';

import { DateTime } from 'luxon';



const RootBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1)
}));

const TextTypography = styled(Typography)({
  fontSize: 15
});

const SyncTimeTypography = styled(Typography)({
  fontSize: 12,
  color: 'grey',
  fontStyle: 'italic'
});



export interface IProps {
  text?: string | number | null;
  syncTime?: DateTime | null;
}

export const FC: React.FC<IProps> = ({
  text,
  syncTime
}) => {
  return (
    <RootBox>
      <TextTypography>
        {text ?? '-'}
      </TextTypography>

      <SyncTimeTypography>
        {syncTime ? `Synced at ${syncTime?.toFormat('yyyy-MM-dd @ HH:mm a')}` : ''}
      </SyncTimeTypography>
    </RootBox>
  );
};
